import { Controller } from "@hotwired/stimulus";

// Reveals a ritual kind's preset list when its enable checkbox is ticked.
//
// The preset list markup is server-rendered with a `hidden` class on kinds
// that were not previously enabled (see Rituals::PresetListComponent).
// Without this controller the checkbox toggles the form value but never
// un-hides the radios, so a user enabling a new kind could not pick a
// preset and "Save selection" appeared to do nothing.
export default class extends Controller {
  static targets = [ "checkbox", "list" ]

  connect() {
    this.sync()
  }

  // Bound to the checkbox's `change` event.
  sync() {
    this.listTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }
}
